const {
  Box,
  LinearProgress,
  Typography,
  Paper,
} = require("@mui/material");

function UploadProgress({ progress, filename, filesize }) {
  return (
    <Paper
      elevation={3}
      sx={{
        backgroundColor: "#ffff",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        my: 0.5,
        py: 1,
        borderRadius: "10px",
        px: 2,
        width: {
          sm: "100%",
          md: "300px",
        },
      }}
      flexDirection={"col"}
      gap={1}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            flex:1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          variant="body2"
        >
          {filename}
        </Typography>
        <Typography sx={{ color: "text.secondary", minWidth: "fit-content" }} variant="body2">{filesize}</Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`${Math.round(progress)}%`}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

export default UploadProgress;
